import { createContext } from 'react';
export const SelectionGroupContextDispatcher = /*#__PURE__*/createContext({
  onChangeSelection: () => {},
  active: ''
});
export const SelectionGroupContextData = /*#__PURE__*/createContext({});